import MatchedPhotoSelectionAction from './MatchedPhotoSelectionAction';

export default MatchedPhotoSelectionAction;
